/**
 * @author Radek Liška <ing.radek.liska@gmail.com>
 * @copyright Ki-Wi Digital s.r.o.
 * @license
 * All Rights Reserved.
 * Unauthorized copying of this file is strictly prohibited.
 * Proprietary and confidential.
 */

// @ts-check

/* eslint-env browser */

import get from 'lodash/get';
import isArray from 'lodash/isArray';

import { errorWithLevelWarning } from '../../error/error-with-level';
import { fetchWithTimeout } from '../../fetch/fetch';
import CommunicatorUtility from '../utility/communicator-utility';

/**
 * Komunikátor aktualizací zařízení pro Ki-Wi Server.
 */
class CommunicatorUpdate {
  // TODO #626: Refaktorovat na ServerDeviceId.
  /**
   * Doručí informace o aktualizaci zařízení.
   * @param {string} deviceId Identifikátor Ki-Wi zařízení, které chce komunikovat.
   * @param {string} serverUrl URL adresa Ki-Wi Server pro komunikaci.
   * @returns {Promise<Object>} Informace o aktualizaci.
   */
  static fetch(deviceId, serverUrl) {
    return (
      fetchWithTimeout(`${serverUrl}/api/device/${deviceId}/update`, {
        method: 'GET'
      })
        // Snížení priority logování pro chyby síťového spojení.
        .catch((error) => {
          throw errorWithLevelWarning(error);
        })
        .then((response) => {
          // Snížení priority logování pro chyby ze serveru.
          if (!response.ok) {
            throw errorWithLevelWarning(
              new RangeError(`Invalid HTTP status "${response.status}".`)
            );
          }
          return response.json();
        })
        .then((json) => CommunicatorUpdate.parse(json))
    );
  }

  /**
   * Zpracuje aktualizaci zařízení.
   * @param {Object | null | undefined} json Odpověď na aktualizaci zařízení.
   * @returns {Object | null} Informace o aktualizaci.
   */
  static parse(json) {
    let urlArray;
    const urls = get(json, 'urls');
    if (isArray(urls)) {
      urlArray = urls.map((url) => CommunicatorUtility.parseStringOrNull(url));
    } else {
      urlArray = [];
    }
    return {
      urlArray,
      version: CommunicatorUtility.parseStringOrNull(get(json, 'appVersion'))
    };
  }
}

export default CommunicatorUpdate;
